import { faLessThanEqual } from "@fortawesome/free-solid-svg-icons";
import {
  CASHMANAGE_ADD_MODAL_SHOW,
  CASHMANAGE_IS_REGISTOROPEN,
  CASHMANAGE_IS_REGISTOR_LOADING,
  OPENCLOSE_STORE_OUTLETS,
  OPENCLOSE_SELECTED_STORE_OUTLETS,
  OPENCLOSE_OUTLETS_REGISTERS,
  OPENCLOSE_SELECTED_OUTLETS_REGISTERS,
  OPENCLOSE_REGOUTLETS_LOADING,
  OPENCLOSE_CLOSEDREG_LOADING,
  OPENCLOSE_CLOSEDREG_DATA,
  OPENCLOSE_CASHLISTING_LOADING,
  OPENCLOSE_CASHLIST_DATALOAD,
  OPENCLOSE_LISTING_DATALOAD,
  SALEHISTORY_CUSTOMER_SHOW,
  SALEHISTORY_CUSTOMER_LOAD,
  SEND_EMAIL_MODAL_SHOW,
  STORE_USERS,
  SELL_SCREEN_LOADING,
  SELL_PRODUCT_DETAIL,
  SELL_VARIANTS_PRODUCT,
  SELL_SELECTED_PRODUCTS,
  SELL_SELECTED_SINGLE_PRODUCT,
  SALE_PRICEBOOKS,
  SALE_PROMOTIONS,
  CUSTOMERS_SEARCH_DATA,
  USER_SUBS_INFO,
  SHOW_COMPLETE_SALE,
  SALE_PRODUCT_JSON,
  SALE_PAYMENT_DATA,
  CUSTOMERS_SEARCH_DATA_FOR_HISTORY,
  IS_SALE_PAYMENT_DONE,
  CURRENT_SALES_ORDER_DATA,
  CURRENT_ORDER_GUID_ID,
  CURRENT_SALES_ORDER_STATUS_DATA,
  IS_DISCARD_SALE,
  REFUND_SALE_STATUS,
  SALE_PROGRESS_MODAL_SHOW,
  TEMP_SALES_ORDER_DATA,
  IS_SHOW_RETURN_DIALOG,
  CHILD_DATA,
  IS_FILTER_SALE_CALL,
  FILTER_SALE_ID,
  LOAD_ATTRIBUTE_DATA,
  SELLATTRIBUTES,
  ISSHOWSELLATTRIBUTE,
  SELLATTRIBUTESGROUPS,
  SELLATTRIBUTELOADING,
  SELLSELECTEDATTRIBUTES,
  PRODSVARIANTS,
  INVENTORYPOPUP,
  SELLACTIONLOG,
  ShowNumpad,
  NumPadType,
  NumRelateData,
  NumDataChange,
  MOUNTSELLATTRIBTABS,
  MOUNTSELLATTRIBTABS_TYPE,
  SHOW_QUICK_KEY,
  ShowNumpadForDiscount,
  ShowNumpadForPayment
} from "../../constants/ActionTypes";
import { ATTRIB_MODAL_TYPES } from "../../constants/MobAppConstants";

const initialSettings = {
  //**********CASH_MANAGEMENT************
  cashManageAddModalShow: false,
  cashManageIsRegistorOpen: false,
  cashManageIsRegistorLoading: true,
  cashListingLoading: true,
  cashListingDataLoading: true,
  openCloseRegOutletsLoading: true,
  openCloseStoreOutlets: [],
  openCloseSelectedStoreOutlets: {},
  openCloseOutletReg: [],
  openCloseSelectedOutletReg: {},
  openCloseRegClosedLoading: true,
  openCloseListingDataLoad: true,
  opencloseRegClosedData: [],
  //**********SALE_HISTORY************
  saleHistoryCustomerShow: false,
  saleHistoryCustomerLoad: true,
  sendEmailModalShow: false,
  getStoreUsers: [],
  //**********SELL_SCREEN************
  getSellScreenLoading: true,
  getSellProductDetails: [],
  getSellVariantsProduct: [],
  getSellSelectedProducts: [],
  getSellSelectedSingleProduct: {},
  salePriceBooks: [],
  salePromotions: [],
  customerSearchData: {},
  userSubInfo: {},
  getIsShowCompleteSale: false,
  saleProductJsonData: [],
  salePaymentData: {},
  customerSearchDataForHistory: {},
  isSalePaymentDone: false,
  currentSalesOrderData: {},
  currentOrderGuidID: "",
  currentSalesOrderStatusData: [],
  isDiscardSale: false,
  refundSaleStatus: 0, // 0 = Not Refund, 1 = Refund Allow, 2 = Already Refunded,
  saleProgressModalShow: false,
  tempSalesOrderData: [],
  isShowReturnDialog: false,
  getChildData: [],
  isFilterSaleChange: false,
  filterSaleID: "",
  isloadAttributeData: "",
  sellAttributesGroups: [],
  sellAttributes: [],
  showSellAttribute: false,
  sellAttributeLoading: false,
  sellSelAttributes: [],
  checkVariantProds: [],
  showInventoryPopup: false,
  sellActionLog: [],
  showNumPad: false,
  numPadType: 0, // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  numPadData: {},
  numDataChange: 0,
  mountSellAttribTabs: false,
  mountSellAttribTabs_type: 0,
  showQuickKeys: false,
  showNumPadForDiscount: false,
  showNumPadForPayment: false
};

const Sell = (state = initialSettings, action) => {
  switch (action.type) {
    //**********CASH_MANAGEMENT************
    case CASHMANAGE_ADD_MODAL_SHOW:
      return {
        ...state,
        cashManageAddModalShow: action.payload,
      };
    case CASHMANAGE_IS_REGISTOROPEN:
      return {
        ...state,
        cashManageIsRegistorOpen: action.payload,
      };
    case CASHMANAGE_IS_REGISTOR_LOADING:
      return {
        ...state,
        cashManageIsRegistorLoading: action.payload,
      };
    case OPENCLOSE_CASHLISTING_LOADING:
      return {
        ...state,
        cashListingLoading: action.payload,
      };
    case OPENCLOSE_CASHLIST_DATALOAD:
      return {
        ...state,
        cashListingDataLoading: action.payload,
      };
    //**********OPEN_CLOSE************
    case OPENCLOSE_STORE_OUTLETS:
      return {
        ...state,
        openCloseStoreOutlets: action.payload,
      };
    case OPENCLOSE_SELECTED_STORE_OUTLETS:
      return {
        ...state,
        openCloseSelectedStoreOutlets: action.payload,
      };
    case OPENCLOSE_OUTLETS_REGISTERS:
      return {
        ...state,
        openCloseOutletReg: action.payload,
      };
    case OPENCLOSE_SELECTED_OUTLETS_REGISTERS:
      return {
        ...state,
        openCloseSelectedOutletReg: action.payload,
      };
    case OPENCLOSE_REGOUTLETS_LOADING:
      return {
        ...state,
        openCloseRegOutletsLoading: action.payload,
      };
    case OPENCLOSE_CLOSEDREG_LOADING:
      return {
        ...state,
        openCloseRegClosedLoading: action.payload,
      };
    case OPENCLOSE_CLOSEDREG_DATA:
      return {
        ...state,
        opencloseRegClosedData: action.payload,
      };
    case OPENCLOSE_LISTING_DATALOAD:
      return {
        ...state,
        openCloseListingDataLoad: action.payload,
      };
    //**********SALE_HISTORY************
    case SALEHISTORY_CUSTOMER_SHOW:
      return {
        ...state,
        saleHistoryCustomerShow: action.payload,
      };
    case SALEHISTORY_CUSTOMER_LOAD:
      return {
        ...state,
        saleHistoryCustomerLoad: action.payload,
      };
    case SEND_EMAIL_MODAL_SHOW:
      return {
        ...state,
        sendEmailModalShow: action.payload,
      };
    case STORE_USERS:
      return {
        ...state,
        getStoreUsers: action.payload,
      };
    //**********SELL_SCREEN************
    case SELL_SCREEN_LOADING:
      return {
        ...state,
        getSellScreenLoading: action.payload,
      };
    case SELL_PRODUCT_DETAIL:
      return {
        ...state,
        getSellProductDetails: action.payload,
      };
    case SELL_VARIANTS_PRODUCT:
      return {
        ...state,
        getSellVariantsProduct: action.payload,
      };
    case SELL_SELECTED_PRODUCTS:
      return {
        ...state,
        getSellSelectedProducts: action.payload,
      };
    case SELL_SELECTED_SINGLE_PRODUCT:
      return {
        ...state,
        getSellSelectedSingleProduct: action.payload,
      };
    case SALE_PRICEBOOKS:
      return {
        ...state,
        salePriceBooks: action.payload,
      };
    case SALE_PROMOTIONS:
      return {
        ...state,
        salePromotions: action.payload,
      };
    case CUSTOMERS_SEARCH_DATA:
      return {
        ...state,
        customerSearchData: action.payload,
      };
    case USER_SUBS_INFO:
      return {
        ...state,
        userSubInfo: action.payload,
      };
    case SHOW_COMPLETE_SALE:
      return {
        ...state,
        getIsShowCompleteSale: action.payload,
      };

    case SALE_PRODUCT_JSON:
      return {
        ...state,
        saleProductJsonData: action.payload,
      };
    case CUSTOMERS_SEARCH_DATA_FOR_HISTORY:
      return {
        ...state,
        customerSearchDataForHistory: action.payload,
      };
    case SALE_PAYMENT_DATA:
      return {
        ...state,
        salePaymentData: action.payload,
      };
    case IS_SALE_PAYMENT_DONE:
      return {
        ...state,
        isSalePaymentDone: action.payload,
      };
    case CURRENT_SALES_ORDER_DATA:
      return {
        ...state,
        currentSalesOrderData: action.payload,
      };
    case CURRENT_ORDER_GUID_ID:
      return {
        ...state,
        currentOrderGuidID: action.payload,
      };
    case CURRENT_SALES_ORDER_STATUS_DATA:
      return {
        ...state,
        currentSalesOrderStatusData: action.payload,
      };
    case IS_DISCARD_SALE:
      return {
        ...state,
        isDiscardSale: action.payload,
      };
    case REFUND_SALE_STATUS:
      return {
        ...state,
        refundSaleStatus: action.payload,
      };

    case SALE_PROGRESS_MODAL_SHOW:
      return {
        ...state,
        saleProgressModalShow: action.payload,
      };

    case TEMP_SALES_ORDER_DATA:
      return {
        ...state,
        tempSalesOrderData: action.payload,
      };
    case IS_SHOW_RETURN_DIALOG:
      return {
        ...state,
        isShowReturnDialog: action.payload,
      };
    case CHILD_DATA:
      return {
        ...state,
        getChildData: action.payload,
      };
    case IS_FILTER_SALE_CALL:
      return {
        ...state,
        isFilterSaleChange: action.payload,
      };
    case FILTER_SALE_ID:
      return {
        ...state,
        filterSaleID: action.payload,
      };
    case LOAD_ATTRIBUTE_DATA:
      return {
        ...state,
        isloadAttributeData: action.payload,
      };

    case SELLATTRIBUTES:
      return {
        ...state,
        sellAttributes: action.payload,
      };
    case SELLATTRIBUTESGROUPS:
      return {
        ...state,
        sellAttributesGroups: action.payload,
      };
    case ISSHOWSELLATTRIBUTE:
      return {
        ...state,
        showSellAttribute: action.payload,
      };
    case SELLATTRIBUTELOADING:
      return {
        ...state,
        sellAttributeLoading: action.payload,
      };
    case SELLSELECTEDATTRIBUTES:
      return {
        ...state,
        sellSelAttributes: action.payload,
      };
    case PRODSVARIANTS:
      return {
        ...state,
        checkVariantProds: action.payload,
      };
    case INVENTORYPOPUP:
      return {
        ...state,
        showInventoryPopup: action.payload,
      };
    case SELLACTIONLOG:
      return {
        ...state,
        sellActionLog: action.payload,
      };
    case ShowNumpad:
      return {
        ...state,
        showNumPad: action.payload
      }
    case ShowNumpadForDiscount:
      return {
        ...state,
        showNumPadForDiscount: action.payload
      }
    case ShowNumpadForPayment:
      return {
        ...state,
        showNumPadForPayment: action.payload
      }
    case NumPadType:
      return {
        ...state,
        numPadType: action.payload,
      };
    case NumRelateData:
      return {
        ...state,
        numPadData: action.payload,
      };
    case NumDataChange:
      return {
        ...state,
        numDataChange: action.payload,
      };
    case MOUNTSELLATTRIBTABS:
      return {
        ...state,
        mountSellAttribTabs: action.payload,
      };
    case MOUNTSELLATTRIBTABS_TYPE:
      return {
        ...state,
        mountSellAttribTabs_type: action.payload,
      };
    case SHOW_QUICK_KEY:
      return {
        ...state,
        showQuickKeys: action.payload,
      };
    default:
      return state;
  }
};

export default Sell;
